import { render, staticRenderFns } from "./CPTemp4.vue?vue&type=template&id=00649e5d&scoped=true&"
import script from "./CPTemp4.vue?vue&type=script&lang=js&"
export * from "./CPTemp4.vue?vue&type=script&lang=js&"
import style0 from "./CPTemp4.vue?vue&type=style&index=0&id=00649e5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00649e5d",
  null
  
)

export default component.exports